module.exports = __webpack_public_path__ + "img/经营平台1.f92f39ca.png";